import { defineComponent as _defineComponent } from 'vue'
import { inject } from 'vue';


/**
 * @deprecated: To be replaced by TableActionButton2 in the (near, I hope) future.
 */
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TableActionButton',
  props: {
    icon: null,
    pack: { default: 'mdi' },
    disabled: { type: Boolean, default: false },
    hidden: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  emits: ['click'],
  setup(__props: any, { emit }) {



const shouldUseMenu = inject<boolean>('shouldUseMenu', false);



return { __sfc: true,shouldUseMenu, emit }
}

})